/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-09-12 14:49:54
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-26 10:32:43
 * @FilePath: \合联\oms\src\api\finance\segmentDetails.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/finance/section/hq/detail/'

export const apis = buildApi({
  get: [name + 'sync', name + 'bgTdExport/:id&bgTdExport', '/extract/clientExtract/bgTdExport/:id&bgTdExportV2', '/extract/clientExtract/tdExport/:id&tdExportV2', name + 'tmExtractDetails/:id&tmExtractDetails', name + 'bayanFiles/:id&bayan', '/extract/clientExtract/tmExtractList', '/extract/clientExtract/shipmentDetails/:id&shipmentDetails'],
  post: [name+'tax/index&tax',name + 'index&list', name + 'recalculate', name + 'createBill', name + 'tdExport',, name + 'setExtractFinance'],
  upload:[name+'uploadWeight&excel']
})
